import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { LanguageSelector } from '../language-selector/language-selector';
import { UserMenu } from '../user-menu/user-menu';
import { AuthService } from '../../../core/api/auth.service';
import { RouterLink } from '@angular/router';
import { TK } from '../../../core/i18n';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  imports: [NgOptimizedImage, LanguageSelector, UserMenu, RouterLink, TranslatePipe],
  template: `
    <header>
      <div class="header-content">
        <div class="header-logo">
          <a [routerLink]="authService.isAuthenticated() ? '/user/object' : '/'">
            <img
              ngSrc="/images/rigoplan_logo.svg"
              width="300"
              height="35"
              alt="RigoPlan Logo"
              priority
            />
          </a>
        </div>
        <div class="header-nav" aria-label="Main navigation">
          <a routerLink="/about" [innerHTML]="TK.header.aboutRigoplan | translate"></a>

          <app-language-selector />

          @if (authService.isAuthenticated()) {
            <app-user-menu />
          }
        </div>
      </div>
    </header>
  `,
  styles: `
    header {
      border-bottom: 1px solid var(--color-border-light);

      .header-content {
        max-width: var(--max-page-width);
        margin-inline: auto;
        padding-inline: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 4.5rem;

        .header-logo {
          img {
            cursor: pointer;
          }
        }

        .header-nav {
          display: flex;
          align-items: center;
          gap: 2rem;
          font-size: 0.875rem;

          a {
            text-decoration: underline;
            &:hover {
              color: var(--color-text-strong);
            }
          }
        }
      }
    }
  `,
})
export class Header {
  authService = inject(AuthService);
  protected readonly TK = TK;
}
